import React from 'react';
import { PieceType } from '../../services/zodiacEngine/types';
import { useTheme } from '../Providers/ThemeContext';
import { useLanguage } from '../Providers/LanguageContext';
import styles from './MoveContext.module.css';

interface MoveContextProps {
  selectedPiece: PieceType;
  selectedAbility?: string;
  scenarioDescription?: string | null;
  postMoveDescription?: string | null;
}

function MoveContext({ selectedPiece, selectedAbility, scenarioDescription, postMoveDescription }: MoveContextProps) {
  const { theme } = useTheme();
  const { t } = useLanguage();

  const pieceName = t(`pieces.${selectedPiece}`);

  const renderAbilityContent = () => {
    // Live animation scenario takes priority — that's the only reliable source.
    if (scenarioDescription && selectedAbility) {
      const translationKey = selectedAbility.toLowerCase().replace(/\s+/g, '');
      const abilityTitle = t(`moves.${translationKey}`);
      return (
        <>
          <div className={styles.contextSection}>
            <h4 className={styles.sectionTitle}>{abilityTitle}</h4>
            <p className={styles.sectionContent}>{scenarioDescription}</p>
          </div>
          {postMoveDescription && (
            <div className={styles.contextSection}>
              <p className={styles.sectionContent}>{postMoveDescription}</p>
            </div>
          )}
        </>
      );
    }

    return (
      <div className={styles.emptyState}>
        <p>{t('moveContext.emptyState')}</p>
      </div>
    );
  };

  return (
    <div className={`${styles.moveContextContainer} ${theme === 'dark' ? styles.dark : ''}`}>
      <h3>{t('moveContext.title')}</h3>
      <div className={styles.scrollBox}>
        <div className={styles.pieceHeader}>
          <div className={styles.pieceName}>{pieceName}</div>
          <div className={styles.pieceIcon}>
            <img
              src={`/Icons/${selectedPiece}-light.png`}
              alt={selectedPiece}
              className={styles.pieceImage}
            />
          </div>
        </div>

        {renderAbilityContent()}
      </div>
    </div>
  );
}

export default MoveContext;